export const forms = {
  tpsp: {
    apiURL: "https://finio.sprintenterprise.co.uk/api/post-form-tpsp.php",
    steps: [
      {
        name: "Form Step 1",
        sections: [
          { name: "IncludeHtml", parameters: { includeKey: "intro" } },
          { name: "PersonalDetails", parameters: {} },
          { name: "PlatformAuthorisation", parameters: {} },
          { name: "TermsAndConditions", parameters: {} },
          // { name: "UnavailablePlatforms", parameters: {} },
        ],
      },
    ],
    thanksPage: {
      sections: [{ name: "IncludeHtml", parameters: { includeKey: "thanks" } }],
    },
  },

  "tpsp-commercial": {
    apiURL: "https://finio.sprintenterprise.co.uk/api/post-form-tpsp.php",
    steps: [
      {
        name: "Personal Details",
        sections: [
          { name: "IncludeHtml", parameters: { includeKey: "intro" } },
          { name: "PersonalDetails", parameters: {} },
        ],
      },
      {
        name: "Platform Selection",
        sections: [{ name: "PlatformSelection", parameters: {} }],
      },
      {
        name: "Platform Quote",
        sections: [{ name: "PlatformQuote", parameters: {} }],
      },
      {
        name: "Platform Authorisation",
        sections: [
          {
            name: "PlatformAuthorisation",
            parameters: { useSelectedPlatforms: true },
          },
          { name: "TermsAndConditions", parameters: {} },
        ],
      },
    ],
    thanksPage: {
      sections: [{ name: "IncludeHtml", parameters: { includeKey: "thanks" } }],
    },
  },
};
